import { SurveysContext } from "@/context/SurveysContext";
import useApi from "@/hooks/useApi";
import { Survey } from "@velaro/velaro-component-lib";
import AppLoading from "@/components/AppLoading";
import React, { useCallback, useEffect, useState } from "react";

function tryParseJson(val: any): any {
  if (val == null || typeof val === "object") return val;
  try {
    return JSON.parse(val);
  } catch {
    return null;
  }
}

function deserializeSurveys(data: any[]): any[] {
  return data.map((survey) => ({
    ...survey,
    questions: Array.isArray(survey.questions)
      ? survey.questions.map((q: any) => ({
          ...q,
          visibilityCondition: tryParseJson(q.visibilityCondition),
          hiddenConfig: tryParseJson(q.hiddenConfig)
        }))
      : []
  }));
}

export function SurveysProvider(props: { children: React.ReactNode }) {
  const api = useApi();

  const [loading, setLoading] = useState(true);
  const [surveys, setSurveys] = useState<Survey[]>([]);

  const fetch = useCallback(async () => {
    try {
      const response = await api.messaging.get("Surveys/List");
      const data = await response.json();
      setSurveys(Array.isArray(data) ? deserializeSurveys(data) : []);
    } catch {
      setSurveys([]);
    } finally {
      setLoading(false);
    }
  }, [api.messaging]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  if (loading) {
    return <AppLoading />;
  }

  return (
    <SurveysContext.Provider
      value={{ surveys: surveys, loading: loading, setSurveys }}
    >
      {props.children}
    </SurveysContext.Provider>
  );
}
